import React from 'react'
import Header from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './index.less'
import { getUrl } from '../../utils/deciphering'
import wx from 'weixin-js-sdk'

import sendGiftImg from '../../images/diary/diary_btn_sendgift.png'

import tryImg from '../../images/diary/diary_btn_try.png'
import otherdiaryImg from '../../images/diary/diary_btn_otherdiary.png'
import playImg from '../../images/diary/diary_play.png'
import pauseImg from '../../images/diary/diary_pause.png'
import smallPlayImg from '../../images/diary/diary_unlock_btn_smallPlay.png'
import smallPauseImg from '../../images/diary/diary_unlock_btn_smallPause.png'
import unlockLogoImg from '../../images/diary/diary_unlock_huhuLogo.png'
import cateBgImg from '../../images/diary/diary_unlock_cate_bg.png'

import { getDiaryMission, addPraise } from '../../api/diary'
import { isWeChat, getQueryString, jumpApp, getNickName, timeFormat, formatMTime, getAllTime, baiduStatistics, baiduStatisticsBehaviour, jumpYYB } from '../../utils/utils'
import ShareShadeLayer from '../../components/Sound/shareShadeLayer'
import Share from '../../components/Sound/share'
import { advert } from '../../api/count'
import { getShareContent } from '../../api/share'
import Cookies from 'js-cookie'
import DocumentTitle from 'react-document-title'
import { global } from '../../config/index'

export default class DiaryDetailIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: isWeChat(),
      data: {},
      paused: true,
      firstPaused: true,
      secondPaused: true,
      thirdPaused: true,
      fourthPaused: true,
      sign: '',
      wxShareVisible: false,
      wxShareItem: {},
      shareContent: {},
      clicked: false,
      videoProgress: 0,
      nowTime: "--:--",
      lastTime: "--:--",
      moveTime: 0
    }
  }

  componentWillMount = () => {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (!sign && this.state.client == 1) {
      let url = global.wxAuthorizeBaseUrl + '?op=wxWebDiaryLogin&from_sso_id=' + getQueryString('from_sso_id') + '&invite_type='
        + getQueryString('invite_type') + '&picture_id=' + getQueryString('picture_id') + '&channel_id=' + getQueryString('channel_id')
        + '&diary_id=' + getQueryString('diary_id') + '&base_url=' + global.href + 'diary/index'
      window.location.href = url;
    } else {
      this.setState({
        sign: true
      })
    }
  }

  componentDidMount() {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (sign) {
      this.requestList()
      this.initPlay()
      baiduStatistics();
      this.handlePageCounts();
      setTimeout(function () {
        baiduStatisticsBehaviour('日记分享落地页', '曝光', 'h5_riji_fxy');
      }, 500)
      advert({
        operate: 'diarymission',
        label: 'open_diary_page',
      }).then((res) => { })
    }
  }

  requestList = () => {
    let diary_id = getQueryString('diary_id') ? getQueryString('diary_id') : 0
    let from_sso_id = getQueryString('from_sso_id') ? getQueryString('from_sso_id') : 0
    getDiaryMission({ diary_id: diary_id, from_sso_id: from_sso_id }).then((res) => {
      this.setState({
        data: res
      }, () => {
        let duration = getAllTime(res.diary_mission.second);
        let lastTime = formatMTime(duration)
        this.setState({
          nowTime: '00:00',
          lastTime: lastTime,
        })
        if (this.state.client == 1) {
          this.handleGetShareContent({})
        }
      })
    })
  }

  handleGetShareContent = () => {
    getShareContent({ type: 8 }).then((res) => {
      this.setState({
        shareContent: res
      }, () => {
        this.handleWxShaer({})
      })
    })
  }

  handleWxShaer = (item) => {
    let diary_mission = this.state.data.diary_mission
    let res = this.state.shareContent
    let wxShareVisible = true
    let url = res.url
    if (res.url.indexOf('?') > 0) {
      url += '&'
    } else {
      url += '?'
    }
    url += 'invite_type=' + res.invite_type + '&picture_id=' + res.picture_id + '&channel_id=' + res.channel_id
      + '&diary_id=' + diary_mission.id
    if (item.id) {
      url += '&from_sso_id=' + item.from_sso_id
      advert({
        operate: 'diarymission',
        label: 'share_friend_8',
      }).then((res) => { })
    } else {
      wxShareVisible = false
      url += '&from_sso_id=' + Cookies.get('sso_id')
    }
    this.setState({
      wxShareVisible: wxShareVisible,
      wxShareItem: {
        title: res.name,
        link: url,
        desc: res.detail,
        imgUrl: res.image,
      }
    })
  }

  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  initPlay = () => {
    let audio = this.refs.audio
    let _this = this

    //监听事件
    audio.oncanplay = function () {
      let lastTime = formatMTime(audio.duration)
      _this.setState({
        lastTime: lastTime,
      })
      if (audio.paused) {
        audio.play();
      }
    }
    //开始播放：
    audio.onplay = () => {
      _this.setState({
        paused: false
      })
    }

    //暂停播放：
    audio.onpause = function () {
      _this.setState({
        paused: true
      })
    }

    audio.ontimeupdate = function () { //当浏览器正在获取媒介数据时运行的脚本。
      let nowTime = formatMTime(audio.currentTime);
      _this.setState({
        nowTime: nowTime,
        videoProgress: audio.currentTime / audio.duration * 100
      })
    }

    ///其他Audio实例初始化
    let firstAudio = this.refs.first
    firstAudio.onplay = function () {
      _this.setState({
        firstPaused: false
      })
    }
    firstAudio.onpause = function () {
      _this.setState({
        firstPaused: true
      })
    }

    let secongAudio = this.refs.second
    secongAudio.onplay = function () {
      _this.setState({
        secondPaused: false
      })
    }
    secongAudio.onpause = function () {
      _this.setState({
        secondPaused: true
      })
    }

    let thirdAudio = this.refs.third
    thirdAudio.onplay = function () {
      _this.setState({
        thirdPaused: false
      })
    }
    thirdAudio.onpause = function () {
      _this.setState({
        thirdPaused: true
      })
    }

    let fourthAudio = this.refs.fourth
    fourthAudio.onplay = function () {
      _this.setState({
        fourthPaused: false
      })
    }
    fourthAudio.onpause = function () {
      _this.setState({
        fourthPaused: true
      })
    }

  }

  //页面访问量
  handlePageCounts() {
    setTimeout(function () {
      window._hmt.push(['_trackEvent', "日记分享落地页", "曝光", "h5_riji_fxy", 1]);
    }, 500)
  }


  ///音频播放实例
  audioPlay = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_bf');
    this.pauseAllAudio();
    let audio = this.refs.audio
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }

  firstAudioPlay = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_zj1');
    this.pauseAllAudio();
    let firstAudio = this.refs.first
    if (firstAudio.paused) {
      firstAudio.play();
    } else {
      firstAudio.pause();
    }
  }

  secondAudioPlay = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_zj2');
    this.pauseAllAudio();
    let secondAudio = this.refs.second
    if (secondAudio.paused) {
      secondAudio.play();
    } else {
      secondAudio.pause();
    }
  }

  thirdAudioPlay = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_zj3');
    this.pauseAllAudio();
    let thirdAudio = this.refs.third
    if (thirdAudio.paused) {
      thirdAudio.play();
    } else {
      thirdAudio.pause();
    }
  }

  fourthAudioPlay = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_zj4');
    this.pauseAllAudio();
    let fourthAudio = this.refs.fourth
    if (fourthAudio.paused) {
      fourthAudio.play();
    } else {
      fourthAudio.pause();
    }
  }
  // 暂停函数
  pauseAllAudio = () => {
    var audios = document.getElementsByTagName("audio");
    // 暂停函数
    function pauseAll() {
      var self = this;
      [].forEach.call(audios, function (i) {
        // 将audios中其他的audio全部暂停
        i !== self && i.pause();
      })
    }
    // 给play事件绑定暂停函数
    [].forEach.call(audios, function (i) {
      i.addEventListener("play", pauseAll.bind(i));
    })
  }
  //点赞
  handleAddPraise = (item) => {
    if (item.canpraise == 0) {
      Toast.info('你已经点过赞了', 2)
    }
    else {
      addPraise({ diary_id: item.id, sso_id: Cookies.get('sso_id') }).then((res) => {
        Toast.info('点赞成功', 2)
      })
    }
    this.setState({
      clicked: true
    })
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_sxhh');
  }
  //我的宝贝也来试试
  handleBabyTry = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_wdbbylss')
    jumpYYB('h5_riji_wdbbylss', window.location.pathname)
  }

  handleDownload = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_wdbbylss')
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352'
  }

  //一键领取故事
  onkeyGetGiftForFree = () => {
    baiduStatisticsBehaviour('日记分享落地页', '点击', 'h5_riji_yjlq')
    window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.saker.app.huhu&ckey=CK1404130488352'
  }
  render() {
    let { client, data, sign, wxShareVisible, wxShareItem, paused, firstPaused, secondPaused, thirdPaused, fourthPaused, clicked, videoProgress, nowTime, lastTime } = this.state
    //console.log(this.state.data.diary_mission);
    return (
      <DocumentTitle title={data && data.diary_mission ? data.diary_mission.medalname : '呼呼收音机'}>
        {
          client != 1 || sign ?
            <div id="diary-mainBody">
              <div className="album-detail-wrap">
                <div className="song">
                  <div className="title">
                    <h3>{data && data.diary_mission ? getNickName(data.diary_mission.nickname) : ''}的成长日记</h3>
                  </div>
                  <div className="date">
                    <h3>{data && data.diary_mission ? data.diary_mission.create_date : ''}</h3>
                  </div>

                </div>
                <div className="album-detail-container">
                  <div className="album-box">
                    <div className="album-img">
                      {
                        data && data.diary_mission ?
                          <div className="album-img">
                            <img src={data.diary_mission.image} alt="" />

                            <div className="diary-control">
                              <div className="play-btn">
                                <img onClick={this.audioPlay}
                                  src={paused ? playImg : pauseImg}
                                  alt="" />
                              </div>
                            </div>
                          </div>
                          : ''
                      }
                    </div>
                  </div>


                  <div id="album-control" style={{ flexDirection: 'column' }}>
                    <div className="player-progress-bgview">
                      <div className="player-progress"></div>
                      <div className="player-now-position" catchtap='clickProgress'>
                        <div className="player-progress-now" style={{ width: videoProgress + '%' }}></div>
                        <div className="player-progress-now-circle-view">
                          <div className="player-progress-now-circle "></div>
                        </div>
                      </div>
                    </div>
                    <div className="player-progress-time-view">
                      <span>{nowTime}</span>
                      <span>{lastTime}</span>
                    </div>
                  </div>
                </div>
                {
                  clicked ?
                    <div className="bottomView">
                      <div className="sendGift">
                        <img onClick={this.handleBabyTry} src={tryImg} alt="" />
                      </div>
                      <div className="getGift-bg">
                        <p>{"限量原创故事等你领"}</p>
                      </div>
                    </div>
                    : ''
                }
                {
                  data && data.diary_mission && !clicked ?
                    <div className="bottomView">
                      <div className="sendGift">
                        <img onClick={() => { this.handleAddPraise(data.diary_mission) }} src={sendGiftImg} alt="" />
                      </div>
                      <div className="getGift-bg">
                        <p>{"限量原创故事等你领"}</p>
                      </div>
                    </div>
                    : ''
                }

                <div className="unlockItems">
                  <div className="unlock-Item first">
                    <img src={data && data.diary_mission ? data.diary_mission.image1 : ''} alt="" />
                    <div className="diary-control">
                      <div className="play-btn">
                        <img onClick={this.firstAudioPlay}
                          src={firstPaused ? smallPlayImg : smallPauseImg}
                          alt="" />
                      </div>
                    </div>
                    <div className="cate">
                      <p>{data && data.diary_mission ? data.diary_mission.label1 : ''}</p>
                    </div>
                  </div>
                  <div className="unlock-Item second">
                    <img src={data && data.diary_mission ? data.diary_mission.image2 : ''} alt="" />
                    <div className="diary-control">
                      <div className="play-btn">
                        <img onClick={this.secondAudioPlay}
                          src={secondPaused ? smallPlayImg : smallPauseImg}
                          alt="" />
                      </div>
                    </div>
                    <div className="cate">
                      <p>{data && data.diary_mission ? data.diary_mission.label2 : ''}</p>
                    </div>
                  </div>
                  <div className="unlock-Item third">
                    <img src={data && data.diary_mission ? data.diary_mission.image3 : ''} alt="" />
                    <div className="diary-control">
                      <div className="play-btn">
                        <img onClick={this.thirdAudioPlay}
                          src={thirdPaused ? smallPlayImg : smallPauseImg}
                          alt="" />
                      </div>
                    </div>
                    <div className="cate">
                      <p>{data && data.diary_mission ? data.diary_mission.label3 : ''}</p>
                    </div>
                  </div>

                  <div className="unlock-Item fourth">
                    <img src={data && data.diary_mission ? data.diary_mission.image4 : ''} alt="" />
                    <div className="diary-control">
                      <div className="play-btn">
                        <img onClick={this.fourthAudioPlay}
                          src={fourthPaused ? smallPlayImg : smallPauseImg}
                          alt="" />
                      </div>
                    </div>
                    <div className="cate">
                      <p>{data && data.diary_mission ? data.diary_mission.label4 : ''}</p>
                    </div>
                  </div>

                </div>
                <audio ref="audio" src={data && data.diary_mission ? data.diary_mission.mp3 : ''}
                  style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                        </audio>
                <audio ref="first" src={data && data.diary_mission ? data.diary_mission.mp31 : ''} style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                        </audio>
                <audio ref="second" src={data && data.diary_mission ? data.diary_mission.mp32 : ''} style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                        </audio>
                <audio ref="third" src={data && data.diary_mission ? data.diary_mission.mp33 : ''} style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                        </audio>
                <audio ref="fourth" src={data && data.diary_mission ? data.diary_mission.mp34 : ''} style={{ display: 'none' }}>
                  Your browser does not support the audio element.
                        </audio>
                {
                  client == 1 ? <ShareShadeLayer wxShareVisible={wxShareVisible} onShow={this.onClose('wxShareVisible')} />
                    : ''
                }

                {
                  client == 1 && wxShareItem.title ?
                    <Share obj={wxShareItem} onClose={this.onClose('wxShareVisible')} /> : ''
                }

              </div>
              <div className="bottom-view" onClick={this.onkeyGetGiftForFree}>
                {"一键领取故事"}
              </div>
            </div>
            : ''
        }
      </DocumentTitle>
    );
  }

}